<script setup>
import { onMounted } from 'vue'
import { useDrawerContext } from './useDrawer'

const { hasDrawerFooter } = useDrawerContext()

onMounted(() => {
  hasDrawerFooter.value = true
})
</script>

<template>
  <div
    data-component="CsDrawerFooter"
    class="sticky bottom-0 flex gap-2 justify-end p-4 border-t border-brand-gray-8 dark:border-brand-gray-15 bg-brand-background h-[60px]"
  >
    <slot />
  </div>
</template>
